<template>
  <div :class="{'has-logo':showLogo}">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import router from '../../../router'

export default {
  components: { SidebarItem, Logo },
  props : {
    routes: {
      type: Array,
      default: () => {
        return []
      }
    },
    parentName: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar'
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return false
    }
  }
}
</script>
<style scoped>
.sidebar-title {
  margin: 0 24px;
  font-size: 20px;
  border-bottom: 1px solid #e1e1e1;
}

.sidebar-title h5{
  font-size: 16px;
  color: #303133;
  line-height: 24px;
  font-weight: 500;
  padding-left: 16px;
  margin: 20px 0;
}

#app .sidebar-container .el-scrollbar {
    height: 100%;
    margin-top: 10px;
    padding-left: 8px;
}

</style>
